import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import overtimeActions from "../../_actions/overtimeActions";
import TitleBar from "../_common/TitleBar";
import Table from "../_common/Table";
import OvertimeRequestModal from "./OvertimeRequestModal";
import "./overtime.css";
import { convertDateToMilTime } from "../../_utils/generalUtils";

class Overtime extends Component {
  state = {
    monthFilter: null,
    yearFilter: null,
    approvedFilter: false,
    selectedOvertime: null,
    sortColumn: { path: "submittedOn", order: "desc" },
    showOvertimeRequestModal: false
  };

  columns = [
    {
      path: "submittedOn",
      label: "Date of Req.",
      thClassName: "otList-th-submittedOn",
      content: ot => moment(ot.submittedOn).format("MM/DD/YYYY")
    },
    {
      path: "requestedHours",
      label: "OT Hrs Req.",
      thClassName: "otList-th-reqHours"
    },
    {
      path: "requestForDate",
      label: "OT For",
      thClassName: "otList-th-reqForDate",
      content: ot => moment(ot.requestForDate).format("MM/DD/YYYY")
    },
    {
      path: "projectFullEa",
      label: "Project",
      thClassName: "otList-th-projFullEa"
    },
    {
      path: "justification",
      label: "Reason for OT",
      thClassName: "otList-th-just"
    },
    {
      path: "isApproved",
      label: "Status",
      thClassName: "otList-th-isApproved",
      content: ot => (ot.isApproved ? "Accepted" : "Pending")
    },
    {
      path: "overtimeActualStart",
      label: "Actual Start",
      thClassName: "otList-th-actStart",
      content: ot =>
        ot.overtimeActualStart && convertDateToMilTime(ot.overtimeActualStart)
    },
    {
      path: "overtimeActualFinish",
      label: "Actual Finish",
      thClassName: "otList-th-actFin",
      content: ot =>
        ot.overtimeActualFinish && convertDateToMilTime(ot.overtimeActualFinish)
    }
  ];

  months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];

  getFiveYears = () => {
    const currYear = new Date().getFullYear();
    let yearOptions = [];
    for (let i = 0; i < 5; i++) {
      yearOptions.push((currYear - 4 + i).toString());
    }
    return yearOptions;
  };

  componentDidMount() {
    const { dispatch, user, tabId } = this.props;
    dispatch(overtimeActions.fetchUserOvertimes(user.userId, tabId));
  }

  handleSort = sortColumn => this.setState({ sortColumn });
  handleClick_overtimeTr = selectedOvertime =>
    this.setState({ selectedOvertime });

  handleChange_select = fieldName => selectedOption => {
    this.setState({ [fieldName]: selectedOption });
  };

  handleClick_reqOt = e => {
    e.preventDefault();
    this.toggleOvertimeRequestModal();
  };

  toggleOvertimeRequestModal = () =>
    this.setState({
      showOvertimeRequestModal: !this.state.showOvertimeRequestModal
    });

  getData = () => {
    const { overtimeList } = this.props;
    const { sortColumn } = this.state;
    return _.orderBy(overtimeList, [sortColumn.path], [sortColumn.order]);
  };

  render() {
    const { tabId, user } = this.props;
    const {
      selectedOvertime,
      sortColumn,
      showOvertimeRequestModal
    } = this.state;
    const data = this.getData();
    return (
      <React.Fragment>
        <TitleBar titleText="Log of Overtime & Overtime Preauthorization" />
        <div className="card m-2">
          <div className="card-body p-2">
            <div className="card mb-2">
              <div className="card-body p-2">
                <div className="row">
                  <div className="col-6">
                    <div className="row mb-0">
                      <div className="col pr-1">
                        <small>
                          <b>Employee Name</b>
                        </small>
                      </div>
                      <div className="col px-1">
                        <small>
                          <b>Employee ID</b>
                        </small>
                      </div>
                      <div className="col px-1">
                        <small>
                          <b>Perm Dist-Unit</b>
                        </small>
                      </div>
                      <div className="col px-1">
                        <small>
                          <b>First-line Supervisor</b>
                        </small>
                      </div>
                    </div>
                    <div className="row mt-0">
                      <div className="col pr-1">
                        <span>{user.fullName}</span>
                      </div>
                      <div className="col px-1">
                        <span>{user.employeeNo}</span>
                      </div>
                      <div className="col px-1">
                        <span>{user.distUnit}</span>
                      </div>
                      <div className="col px-1">
                        <span>{}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-8">
                <button
                  type="button"
                  id="advFilter"
                  name="advFilter"
                  className="btn btn-secondary mr-2"
                  onClick={this.handleClick_advFilter}
                  disabled={true}
                >
                  <FontAwesomeIcon icon="filter" className="fa-fw mr-2" />
                  Filter Data...
                </button>
                <button
                  type="button"
                  id="reqOt"
                  name="reqOt"
                  className="btn btn-info"
                  onClick={this.handleClick_reqOt}
                >
                  Request Overtime...
                </button>
              </div>
            </div>
            <Table
              className="table table-sm table-hover"
              data={data}
              idPropName="overtimeId"
              selectedItemId={selectedOvertime && selectedOvertime.overtimeId}
              columns={this.columns}
              sortColumn={sortColumn}
              onSort={this.handleSort}
              handleClick_tr={this.handleClick_overtimeTr}
            />
          </div>
        </div>
        {showOvertimeRequestModal && (
          <OvertimeRequestModal
            showOvertimeRequestModal={showOvertimeRequestModal}
            toggleOvertimeRequestModal={this.toggleOvertimeRequestModal}
            tabId={tabId}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.authentication.user,
  overtimeList: state.overtimes.overtimeList[ownProps.tabId]
    ? state.overtimes.overtimeList[ownProps.tabId]
    : []
});

export default connect(mapStateToProps)(Overtime);
